/**
 * Centralized translations for Hand Hygiene module
 * Contains all labels used across hand hygiene components
 */

export const UsersGroupsSearchScreenLabels = {
    it: {
        userGroupFinder: 'Ricerca Utenti e Gruppi',
        home: 'Home',
        filter: 'Filtro',
        name: 'Nome',
        email: 'Email',
        username: 'Nome utente',
        disabled: 'Disabilitato',
        search: 'Cerca',
        foundElements: 'Risultati trovati',
        lastName: 'Cognome',
        next: 'Avanti',
        previous: 'Indietro',
        unauthorized: 'Il tuo utente non dispone dei permessi necessari',
        atLeastOneFilter: 'Inserire almeno un filtro prima di effettuare la ricerca'
   },

    en: {
        userGroupFinder: 'User & Group Finder',
        home: 'Home',
        filter: 'Filter',
        name: 'Name',
        email: 'Email',
        username: 'Username',
        disabled: 'Disabled',
        search: 'Search',
        foundElements: 'Found Elements',
        lastName: 'Last name',
        next: 'Next',
        previous: 'Previous',
        unauthorized: 'Your user does not have the necessary permissions',
        atLeastOneFilter: 'Please enter at least one filter before searching'
    }
}; 